import React from 'react';
import {SortingAccessor, SortingSelector} from 'searchkit'

class SortingArrowSelector extends SortingSelector {
  sortValue(currentState, sortFieldName) {
    switch (currentState) {
      case 0:
        return "";
      case 1:
        return sortFieldName + "_asc";
      case 2:
        return sortFieldName + "_desc";
      default:
        break;
    }
  }
  currentClass() {
    const currentState = this.getCurrentStateCode();
    switch (currentState) {
      case 0:
        return "fas fa-sort fa-lg";
      case 1:
        return "fas fa-sort-up fa-lg";
      case 2:
        return "fas fa-sort-down fa-lg";
      default:
        break;
    }
  }
  getCurrentStateCode() {
    let currentState = this.searchkit.state.sort;
    let currentStateCode;
    if (currentState) {
      if (this.props.field + '_asc' === currentState) {
        currentStateCode = 1;
      }
      else if (this.props.field + '_desc' === currentState) {
        currentStateCode = 2;
      }
      else {
        currentStateCode = 0;
      }
    }
    else {
      currentStateCode = 0;
    }
    return currentStateCode;
  }

  getNextStateCode() {
    let currentStateCode = this.getCurrentStateCode();
    if (currentStateCode === 2) {
      return 0;
    }
    else {
      return currentStateCode + 1
    }
  }
  setCustomItems(e){
    const searchkit = this.context.searchkit;
    const CurrentSortAccessor = searchkit.getAccessorByType(SortingAccessor);
    CurrentSortAccessor.state.value = this.sortValue(this.getNextStateCode(), this.props.field);
    this.context.searchkit.performSearch();
  }
  render(){
    return (
        <span className={this.currentClass()} onClick={(e) => this.setCustomItems(e)}></span>
      )
  }
}

export default SortingArrowSelector;


// WEBPACK FOOTER //
// ./src/SortingArrowSelector.js